import React from 'react';
import { aboutData, pageHeroImages } from '../mock';

const About = () => {
  return (
    <div className="page-container">
      <section className="page-hero" style={{ backgroundImage: `url(${pageHeroImages.about})` }}>
        <div className="page-hero-overlay"></div>
        <div className="page-hero-content">
          <h1 className="page-title">{aboutData.title}</h1>
        </div>
      </section>

      <section className="about-content-section">
        <div className="section-container">
          {aboutData.sections.map((section, index) => (
            <div key={index} className="about-section-block">
              <h2 className="about-section-heading">{section.heading}</h2>
              <p className="about-section-text">{section.content}</p>
            </div>
          ))}

          <div className="about-closing">
            <p className="about-closing-text">{aboutData.closingText}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
